/* Unload initialized app pixels when a visitor withdraws their consent. */
(function () {
  if (window.__zeyaConsentRefreshInstalled) return;
  window.__zeyaConsentRefreshInstalled = true;
  var wasAllowed = null;
  function processingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return null;
    return privacy.marketingAllowed() && privacy.analyticsProcessingAllowed();
  }
  function rememberConsent() { wasAllowed = processingAllowed(); }
  document.addEventListener('visitorConsentCollected', function () {
    var allowed = processingAllowed();
    if (wasAllowed === true && allowed === false) {
      window.location.reload();
      return;
    }
    wasAllowed = allowed;
  });
  if (window.Shopify && window.Shopify.customerPrivacy) rememberConsent();
  else if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
      if (!error) rememberConsent();
    });
  }
})();
